import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that capitalizes the first letter of a string.
 * Useful for displaying status values, labels, and other text in sentence case.
 *
 * @example
 * {{ 'succeeded' | capitalize }} // Output: Succeeded
 * {{ 'processing' | capitalize }} // Output: Processing
 * {{ 'FAILED' | capitalize }} // Output: Failed
 * {{ value | capitalize }} // Capitalize the first letter
 */
@Pipe({ name: 'capitalize', standalone: true })
export class CapitalizePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    const stringValue = String(value).toLowerCase();
    return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
  }
}
